export { default } from "./DetailContent";
export * from "./DetailContent";
